import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbOperateApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'db-operate';
    }

    /**
     * 获取全部数据
     */
    public async getListAll() {
        return await this.send({}, 'getListAll', Methods.GET);
    }

    public async dbOperateListSaveOrUpdate(datas) {
        return await this.send(datas, 'dbOperateListSaveOrUpdate', Methods.POST);
    }

}